module.exports = __webpack_public_path__ + "static/media/pink_cross.3c651219.svg";